import { styled, ListItemButton } from "@mui/material";

const StyledListItemButton = styled(ListItemButton)`
  color: ${({ theme }) => {
    return theme.palette.text.primary;
  }};
  padding: 16px;
  margin-bottom: 16px;
  flex-direction: column;
  opacity: 0.5;
  text-align: center;
  width: ${({ width }) => width};
  border-radius: ${({ customization }) => `${customization.borderRadius}px`};
  &.MuiListItemText-primary {
    text-align: center;
  }
  &:hover {
    background-color: ${({ theme }) => theme.palette.primary.light}!important;
    opacity: 1;
    color: ${({ theme }) => theme.palette.text.primary} !important;
    &.MuiListItemIcon-root {
      color: #333333 !important;
    }
    & .MuiTypography-root {
      color: ${({ theme }) => theme.palette.text.primary}!important;
    }
  }
  &.Mui-selected {
    opacity: 1;
    background-color: #fff !important;
    box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.1);
    border-bottom: ${({ theme }) => `1px solid ${theme.palette.primary.main}`};
  }
  &.MuiListItemIcon-root {
    color: #9e9e9e !important;
  }
`;
export default StyledListItemButton;
